import PropTypes from 'prop-types';

export const propTypes = {
  slug: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  count: PropTypes.number
};

export const defaultProps = {
  slug: null,
  title: null,
  count: null
};

export const itemPropTypes = {
  type: PropTypes.string,
  slug: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const itemDefaultProps = {
  slug: null,
  type: null,
};

export default { defaultProps, propTypes, itemPropTypes, itemDefaultProps };
